// import { AnimatedGroup } from '@/components/landing/animated-group';

import { Button } from "@workspace/ui/components/button";
import Link from "next/link";
import { EtherealShadow } from "@/components/landing/ethereal-shadow";

// const transitionVariants = {
//   item: {
//     hidden: {
//       opacity: 0,
//       filter: 'blur(12px)',
//       y: 20,
//     },
//     visible: {
//       opacity: 1,
//       filter: 'blur(0px)',
//       y: 0,
//       transition: {
//         type: 'spring',
//         bounce: 0.2,
//         duration: 1.2,
//       },
//     },
//   },
// };

export function HeroSection() {
  return (
    <section className="relative flex min-h-screen items-center">
      {/* Ethereal Shadow Background */}
      <EtherealShadow
        // color="hsl(var(--primary) / 0.4)"
        animation={{ scale: 1, speed: 200 }}
        className="z-0"
        noise={{ opacity: 0.1, scale: 1.0 }}
        sizing="fill"
      />

      {/* Subtle grid background */}
      <div className="absolute inset-0 z-10 opacity-20" />

      {/* Gradient overlay - lighter to show the ethereal shadow */}
      <div className="absolute inset-0 z-20 bg-linear-to-b from-background/60 via-background/75 to-background/95" />

      <div className="relative z-30 px-4 py-20 sm:px-6 md:px-8 md:py-0">
        <div className="flex max-w-[580px] flex-col">
          {/*<AnimatedGroup variants={transitionVariants}>*/}
          <h1 className="mb-6 font-medium text-[24px] text-muted-foreground leading-tight md:mb-10 md:text-[36px]">
            Looking for a job can be hectic.{" "}
            <span className="text-primary">Thankfully, not with us.</span>
          </h1>

          <p className="mb-8 text-muted-foreground text-sm leading-relaxed md:mb-10 md:text-base">
            VacWork simplifies the job search process, connecting job seekers
            with local opportunities and helping employers find the perfect
            candidates for their teams.
          </p>

          <div className="flex flex-col items-start gap-3 sm:flex-row md:gap-4">
            <Button asChild size="lg">
              <Link href="/job-listings">
                <span className="text-nowrap">Find a job</span>
              </Link>
            </Button>
            <Button asChild size="lg" variant="outline">
              <Link href="/jobs?modal=create-job">
                <span className="text-nowrap">Post a job</span>
              </Link>
            </Button>
          </div>

          <p className="mt-4 font-mono text-muted-foreground text-xs">
            Free to join, thousands of local opportunities.
          </p>
          {/* </AnimatedGroup> */}
        </div>
      </div>
    </section>
  );
}
